import axios from 'axios';
import { $find, $qs } from 'fxdom/es';
import { go } from 'fxjs/es';
import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';
import { makeApiUrl } from '../../../../../Util/S/Function/util.js';
import { MShopUtilF } from '../../../../Util/F/Function/module/MShopUtilF.js';
import { MShopAppMypageAccountMuiF } from '../../Account/F/Mui/module/MShopAppMypageAccountMuiF.js';
import { MShopAppMypageAccountTmplS } from '../../Account/S/Tmpl/module/MShopAppMypageAccountTmplS.js';

export const openMyAccountNess = async () => {
  const get_account_url = makeApiUrl('/:lang/@api/my_account/get_account', {
    lang: ET.lang,
  });

  const { data: account_info } = await axios.get(get_account_url);

  await MuiF.openFrame(MShopAppMypageAccountMuiF.frame, async (f, p, [t]) => {
    f.is_modal = !account_info.is_mobile;
    f.always_remove = true;
    f.hide_frame_button_position = 'RIGHT';
    f.hide_frame_button_type = 'X';
    f.header_height = '72px';
    f.title = 'Account Setting';
    f.closing = (account_frame_el) => {
      const is_mobile = MShopUtilF.isMobile();

      if (!is_mobile) return;

      const account_profile_img_src = go(
        account_frame_el,
        $find('.my-account__profile_image__preview img'),
      ).src;
      const mypage_profile_img_el = $qs('.mypage-user__pic > img');

      mypage_profile_img_el.src = account_profile_img_src;
    };

    t.makeData = () => account_info;
    t.template = MShopAppMypageAccountTmplS.nessAccount;
  });
};
